module.exports = __webpack_public_path__ + "static/media/comment-attachment.7a10f76b.svg";